import { publisherFontAwesomeIconsEnum } from 'common/constants/fontAwesomeConst'
import React from 'react'
import { CarouselInterface } from 'src/shared/entities/carousel/carousel.schema'
import { StrictRequired } from 'src/shared/types/typescript-utils/strict-required'
import CarouselArrowLeftUi from './ui/CarouselArrowLeftUi'
import CarouselArrowRightUi from './ui/CarouselArrowRightUi'
import CarouselNavigationItemsUi from './ui/CarouselNavigationItemsUi'
import CarouselNavigationItemUi from './ui/CarouselNavigationItemUi'
import CarouselSliderUi from './ui/CarouselSliderUi'
import CarouselSlideUi from './ui/CarouselSlideUi'
import CarouselUi from './ui/CarouselUi'

type CarouselProps = StrictRequired<
  Pick<
    CarouselInterface,
    | 'padding'
    | 'mobilePadding'
    | 'htmlAttrId'
    | 'showArrows'
    | 'mobileShowArrows'
    | 'controlsColor'
    | 'arrowsColor'
  >
> & {
  children: React.ReactElement[] | React.ReactElement // todo should be ReactElement
  totalItems: number
  switchActiveSlideNumber?: (index: number) => void
  disableOverflow?: boolean
  activeSlideIndex: number
  carouselRef?: React.RefObject<HTMLDivElement>
}

function Carousel({
  controlsColor,
  arrowsColor,
  children,
  padding,
  mobilePadding,
  totalItems,
  htmlAttrId,
  switchActiveSlideNumber,
  disableOverflow = false,
  activeSlideIndex,
  showArrows,
  mobileShowArrows,
  carouselRef,
}: CarouselProps) {
  function handleNavigationClick(index: number) {
    return (event: React.SyntheticEvent) => {
      event.preventDefault()
      event.stopPropagation()
      if (switchActiveSlideNumber) {
        switchActiveSlideNumber(index)
      }
    }
  }

  const nextSlide = activeSlideIndex + 1
  const prevSlide = activeSlideIndex - 1

  const calculatedMobileShowArrows =
    typeof mobileShowArrows === 'undefined' ? showArrows : mobileShowArrows

  return (
    <CarouselUi
      padding={padding}
      mobilePadding={mobilePadding}
      id={htmlAttrId}
      className="carousel-ui"
      ref={carouselRef}
    >
      {prevSlide >= 0 && (
        <CarouselArrowLeftUi
          showArrows={showArrows}
          mobileShowArrows={calculatedMobileShowArrows}
          color={arrowsColor}
          className={publisherFontAwesomeIconsEnum.ChevronLeftSolid}
          onClick={handleNavigationClick(prevSlide)}
        />
      )}
      {nextSlide < totalItems && (
        <CarouselArrowRightUi
          showArrows={showArrows}
          mobileShowArrows={calculatedMobileShowArrows}
          color={arrowsColor}
          className={publisherFontAwesomeIconsEnum.ChevronRightSolid}
          onClick={handleNavigationClick(nextSlide)}
        />
      )}
      <CarouselSliderUi
        className="carousel-slider-ui"
        disableOverflow={disableOverflow}
      >
        {children}
      </CarouselSliderUi>
      <CarouselNavigationItemsUi>
        {Array(totalItems)
          .fill(0)
          .map((_, index) => (
            <CarouselNavigationItemUi
              color={controlsColor}
              active={activeSlideIndex === index}
              key={`slide-${index}`}
              onClick={handleNavigationClick(index)}
            />
          ))}
      </CarouselNavigationItemsUi>
    </CarouselUi>
  )
}

export { CarouselSlideUi }

export default Carousel
